import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import DemographicsSection from "./Demographics";
import AppLayout from "../../layouts/AppLayout";
import AnalyticsTabs from "../../components/tabs/AnalyticsTabs";
import GenderDonut from "../../components/dashboard/GenderDonut";
import DisabilityTypes from "../../pages/analytics/DisabilityTypes";
import Location from "../../pages/analytics/Location";
// import LocationDistrict from "../../pages/analytics/LocationDistrict";
import AgricPieChart from "../../components/dashboard/AgricPieChart";
import EngagementLevel from "../../components/dashboard/EngagementLevel";
import AgricInterestCard from "../../components/dashboard/AgricInterestCard";
import EducationLevel, { EDUCATION_CHART_COLORS } from "../../components/dashboard/EducationLevel";
import EnrollmentStatus, { ENROLLMENT_CHART_COLORS } from "../../components/dashboard/EnrollmentStatus";
import CurrentOccupationCard from "../../components/dashboard/CurrentOccupation";
import Resources from "../../components/dashboard/Resources";
import Safeguarding from "./Safeguarding";


const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL
    
const Analytics = () => {
  const [activeTab, setActiveTab] = useState("Demographics");
  const [genderData, setGenderData] = useState({
    male: 0,
    female: 0,
    malePercentage: null,
    femalePercentage:null,
  });

  useEffect(() => {
    if (activeTab !== "Demographics") return;
    axios
      .get(`${baseUrl}/demographics`)
      .then((response) => {
        const data = response.data;
        if (data.success) {
          setGenderData({
            male: data.male || 0,
            female: data.female || 0,
            malePercentage: data.malePercentage,
            femalePercentage: data.femalePercentage,
          });
        }
      })
      .catch((error) => console.error("Error fetching demographics:", error));
  }, [activeTab]);

  const [enrollmentData, setEnrollmentData] = useState([]);
  const [educationData, setEducationData] = useState([]);

  useEffect(() => {
    if (activeTab !== "Education") return;
    axios
      .get(`${baseUrl}/education-level`)
      .then((response) => {
        const data = response.data;
        if (data.success && data.education) {
          setEducationData(data.education);
        }
      })
      .catch((error) => console.error("Error fetching education level:", error));
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== "Education") return;
    axios
      .get(`${baseUrl}/enrollment-status`)
      .then((response) => {
        const data = response.data;
        if (data.success && data.enrollment) {
          setEnrollmentData(data.enrollment);
        }
      })
      .catch((error) =>
        console.error("Error fetching enrollment status:", error)
      );
  }, [activeTab]);

  const genderDonutData = [
    { name: "Male", value: genderData.male },
    { name: "Female", value: genderData.female },
  ];


  return (
    <div className="min-h-screen bg-gray-100">
      <AppLayout>
        <AnalyticsTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          className="space-y-4"
        />

        <div className="mt-12">
          {activeTab === "Demographics" && (
            <>
              <div>
                <DemographicsSection />
                <div className="mt-12 flex gap-6">
                  <div className="bg-white p-12 rounded-2xl w-[50%] shadow-sm content-center">
                    <p className="text-lg font-semibold mb-1 text-center">
                      Gender Distribution
                    </p>
                    <GenderDonut data={genderDonutData} />
                    <div className="flex justify-center gap-6 mt-4 text-sm">
                      <div className="flex items-center gap-2">
                        <span className="h-4 w-4 bg-yellow-400 rounded" />
                        Male{" "}
                        {genderData.malePercentage
                          ? `${genderData.malePercentage}%`
                          : "—"}
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="h-4 w-4 bg-green-700 rounded" />
                        Female{" "}
                        {genderData.femalePercentage
                          ? `${genderData.femalePercentage}%`
                          : "—"}
                      </div>
                    </div>
                  </div>

                  <div className="bg-white p-12 rounded-2xl w-[50%] shadow-sm text-2xl">
                    <DisabilityTypes />
                  </div>
                </div>
              </div>
            </>
          )}
          {activeTab === "Location" && (
            <div>
              <>
                <div>
                  <Location />
                </div>

                {/* <div className="mt-12">
                  <LocationDistrict />
                </div> */}
              </>
            </div>
          )}
          {activeTab === "Agriculture" && (
            <div className=" grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-2 gap-6">
              <div className="bg-white rounded-2xl p-12 shadow-sm text-2xl">
                <p>
                  <span className="font-bold text-2xl block text-center">
                    Agriculture Interest
                  </span>
                </p>
                <AgricPieChart />
              </div>

              <div className="h-auto">
                <EngagementLevel />
              </div>

              <div className=" col-span-2">
                <AgricInterestCard />
              </div>
            </div>
          )}
          {activeTab === "Education" && (
            <>
              <div className="flex gap-6">
                <div className="bg-white p-12 rounded-2xl w-[50%] shadow-sm text-2xl">
                  <EducationLevel />
                  <div className="grid grid-cols mt-4">
                    {educationData.length > 0 ? (
                      educationData.map((item, index) => (
                        <div key={item.name} className="flex items-center gap-2 text-sm">
                          <span
                            className="h-4 w-4 rounded flex-shrink-0"
                            style={{
                              backgroundColor:
                                EDUCATION_CHART_COLORS[
                                  index % EDUCATION_CHART_COLORS.length
                                ],
                            }}
                          />
                          {item.name} -{" "}
                          <span className="text-gray-700 text-sm">
                            {item.percent}%
                          </span>
                        </div>
                      ))
                    ) : (
                      <p className="text-sm text-gray-500">No education data yet.</p>
                    )}
                  </div>
                </div>

                <div className="bg-white p-12 rounded-2xl w-[50%] shadow-sm text-2xl">
                  <EnrollmentStatus />
                  <div className="grid grid-cols mt-4">
                    {enrollmentData.length > 0 ? (
                      enrollmentData.map((item, index) => (
                        <div key={item.name} className="flex items-center gap-2 text-sm">
                          <span
                            className="h-4 w-4 rounded flex-shrink-0"
                            style={{
                              backgroundColor:
                                ENROLLMENT_CHART_COLORS[
                                  index % ENROLLMENT_CHART_COLORS.length
                                ],
                            }}
                          />
                          {item.name} -{" "}
                          <span className="text-gray-700 text-sm">
                            {item.percent}%
                          </span>
                        </div>
                      ))
                    ) : (
                      <p className="text-sm text-gray-500">No enrollment data yet.</p>
                    )}
                  </div>
                </div>
              </div>

              <div > 
                <CurrentOccupationCard />
              </div>
            </>
          )}
          {activeTab === "Resources" && <div><Resources /></div>}
          {activeTab === "Safeguarding" && <div><Safeguarding /></div>}
        </div>
      </AppLayout>
    </div>
  );
};

export default Analytics;
